import React, { Component } from 'react';
import { Input, Form, Modal } from 'antd';
import { apiAuth } from '../../../../../api/api-auth';
import { alert } from '../../../../../common/utils/alert';

export class ChangePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      disabledOk: false,
      oldPassword: '',
      newPassword: '',
      reNewPassword: ''
    }
    this.username = '';
    this.dataFeild = [
      {
        title: 'Mật khẩu cũ',
        feildName: 'oldPassword',
        validation: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~`!@#$%^&*()_\-:"'?/><.,|\\+= ]).{8,100}$/
      },
      {
        title: 'Mật khẩu mới',
        feildName: 'newPassword',
        validation: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~`!@#$%^&*()_\-:"'?/><.,|\\+= ]).{8,100}$/
      },
      {
        title: 'Nhập lại mật khẩu mới',
        feildName: 'reNewPassword',
        validation: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~`!@#$%^&*()_\-:"'?/><.,|\\+= ]).{8,100}$/
      }
    ]
    this.initValues = {
      oldPassword: '',
      newPassword: '',
      reNewPassword: ''
    }
    this.callBack = null;
  }

  visiableModal = (visible, username, callBack) => {
    this.setState({ visible })
    this.username = username;
    this.callBack = callBack;
  }

  handleOk = () => {
    const func = apiAuth.changePassword

    this.form
      .validateFields()
      .then(async values => {
        this.setState({ disabledOk: true }, async () => {
          try {
            const { oldPassword, newPassword, reNewPassword } = values;
            if (newPassword !== reNewPassword) {
              return alert('error', 'Nhập lại mật khẩu mới không đúng!')
            }

            if (oldPassword === reNewPassword) {
              return alert('error', 'Mật khẩu mới không được trùng với mật khẩu cũ!')
            }
            const result = await func(newPassword, oldPassword, this.username);
            if (result.status === 'success') {
              alert('success', 'Cập nhật thành công')
              this.setState({ disabledOk: false, visible: false });
              this.form.setFieldsValue(this.initValues)
              this.callBack && this.callBack();
            } else {
              this.setState({ disabledOk: false })
              alert('error', result.data.message)
            }
          } catch (error) {
            alert('error', 'Network Error')
            this.setState({ disabledOk: false })
          }
        });
      })
      .catch(info => {

      });
  }

  handleCancel = () => {
    this.form.setFieldsValue(this.initValues)
    this.visiableModal(false)
  }

  render() {
    const { visible, disabledOk } = this.state;

    return (

      <Modal
        wrapClassName={'customer-modal change-password'}
        title={'Đổi mật khẩu'}
        visible={visible}
        onOk={() => this.handleOk()}
        // okButtonProps={{ disabled: disabledOk }}
        cancelText="Huỷ"
        okText={"Lưu thay đổi"}
        onCancel={this.handleCancel}
      >

        <Form

          initialValues={this.initValues}
          ref={ref => this.form = ref}
          layout="vertical"
        >
          {this.dataFeild.map(feild => {
            return <Form.Item
              key={feild.feildName}
              label={feild.title}
              name={feild.feildName}

              rules={feild.feildName !== 'oldPassword' ? [
                ({ getFieldValue }) => ({
                  validator(rule, v) {
                    if (!v) {
                      return Promise.reject(`Vui lòng nhập Mật khẩu!`);
                    }
                    if (feild?.validation.test(v)) {
                      return Promise.resolve()
                    }
                    return Promise.reject('Mật khẩu không đúng định dạng! Mật khẩu phải có ít nhất 8 ký tự, bao gồm ít nhất 1 ký tự viết hoa, 1 ký tự đặc biệt, 1 ký tự số');
                  },
                })
              ] : [
                  ({ getFieldValue }) => ({
                    validator(rule, v) {
                      if (!v) {
                        return Promise.reject(`Vui lòng nhập Mật khẩu!`);
                      }
                      if (feild?.validation.test(v)) {
                        return Promise.resolve()
                      }
                      return Promise.reject('Mật khẩu không đúng định dạng!');
                    },
                  })
                ]}
            >
              <Input type="password" />
            </Form.Item>
          })}
        </Form>
      </Modal>
    )
  }
}
